<template>
  <v-layout>
    <div class="col">
      <v-store-user-info/>

      <article class="shopping-cart">
        <header>
          <h1>{{ $t('cart.title') }}</h1>
        </header>
        <v-cart
          v-if="!isEmpty && cartVisible"
          :cart-product-items="cartProductItems"
          :total-amount-with-vat="totalAmountWithVat"
          :total-vat-amount="totalVatAmount"
          @cartItemRemoved="cartItemRemoved"/>
        <div v-if="isEmpty" class="inner">
          <p v-html="$t('cart.emptyNotification')"/>
        </div>
      </article>
      <article>
        <div class="inner">
          <nav class="flow-controls">
            <a class="button alt" href="javascript:void(0);" @click="goToProductOverview">{{ $t('cart.continueShopping') }}</a>
            <a v-show="!isEmpty" :class="['button', {disabled: serviceError!==null}]" href="javascript:void(0);" @click="goToPayment">
              {{ $t('cart.goToPayment') }}
            </a>
          </nav>
        </div>
      </article>

      <article v-if="combiDealDiscountSuggestions.length" class="combi-deal-suggestions">
        <hr>
        <header>
          <h1>{{ $t('cart.combiDealDiscountSuggestionsTitle') }}</h1>
        </header>
        <p v-for="(combiDealDiscountSuggestion, key) in combiDealDiscountSuggestions" :key="`combi-deal-discount-suggestion-${key}`">
          {{ $t('cart.combiDealDiscountSuggestion', combiDealDiscountTranslationParameters(combiDealDiscountSuggestion)) }}
        </p>
        <p>{{ $t('cart.combiDealDiscountFootNote') }}</p>
      </article>

      <v-modal v-if="removedNotificationVisible"
               id="cartItemRemovedNotificationModal"
               @close="closeRemovedNotificationModal">
        <h2>&nbsp;</h2>
        <p>{{ $t('cart.removedNotificationModalIntro') }}</p>
      </v-modal>
      <v-modal v-if="serviceErrorNotificationVisible"
               id="errorNotificationModal"
               @close="closeErrorNotificationModal">
        <h2>&nbsp;</h2>
        <p>{{ $t('generic.service-error') }}</p>
      </v-modal>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import VLayout from '../layouts/PaymentFlow'
import VCart from '../components/Cart'
import VStoreUserInfo from '../components/user/StoreUserInfo'
import VModal from '../components/modals/Modal'
import bodyClassMixin from '../mixins/body-class'
import { CombiDealDiscountSuggestion } from '../types/combi-deal-discount-suggestion'

export default {
  name: 'CartPage',
  components: {
    VLayout,
    VStoreUserInfo,
    VCart,
    VModal
  },
  mixins: [
    bodyClassMixin
  ],
  data () {
    return {
      regionSelectionModalVisible: false,
      removedNotificationVisible: false,
      cartVisible: false,
      serviceError: null,
      serviceErrorNotificationVisible: false
    }
  },
  computed: {
    ...mapGetters({
      cartProductItems: 'cart/cartProductItems',
      totalAmountWithVat: 'cart/totalAmountWithVat',
      totalVatAmount: 'cart/totalVatAmount',
      overviewRoute: 'cart/overviewRoute',
      paymentRoute: 'cart/paymentRoute'
    }),
    ...mapState({
      combiDealDiscountSuggestions: state => state.cart.combiDealDiscountSuggestions
    }),
    isEmpty () {
      return this.cartProductItems.length === 0
    }
  },
  mounted: async function () {
    try {
      this.$store.dispatch('cart/updateCombiDealDiscountSuggestions')
      await this.$store.dispatch('cart/updatePriceSpecification')
      this.serviceErrorNotificationVisible = false
      this.cartVisible = true
    } catch (error) {
      this.serviceError = error
      this.serviceErrorNotificationVisible = true
    }
  },
  methods: {
    cartItemRemoved: async function (cartItem) {
      try {
        await this.$store.dispatch('cart/removeItemFromOrderById', cartItem.orderItemId)
        this.serviceError = null
        this.serviceErrorNotificationVisible = false
        this.openRemovedNotificationModal()
      } catch (error) {
        this.serviceError = error
        this.serviceErrorNotificationVisible = true
      }
    },
    openRemovedNotificationModal () {
      this.removedNotificationVisible = true
    },
    closeRemovedNotificationModal () {
      this.removedNotificationVisible = false
    },
    closeErrorNotificationModal () {
      this.serviceErrorNotificationVisible = false
    },
    goToPayment () {
      if (this.serviceError !== null) {
        this.serviceErrorNotificationVisible = true
        return
      }

      this.$router.push({ name: this.paymentRoute, params: { lang: 'nl' } }).catch(() => {})
    },
    goToProductOverview () {
      this.$router.push({ name: this.overviewRoute, params: { lang: 'nl' } }).catch(() => {})
    },
    combiDealDiscountTranslationParameters (combiDealDiscountSuggestion: CombiDealDiscountSuggestion) {
      return {
        suggestedTitles: this.formatSuggestedTitle(combiDealDiscountSuggestion.suggestedTitles),
        suggestedForTitles: this.formatSuggestedTitle(combiDealDiscountSuggestion.suggestedForTitles),
        discount: combiDealDiscountSuggestion.discount.isPercentage
          ? this.$n(combiDealDiscountSuggestion.discount.scalarAmount / 100, 'percent')
          : this.$n(combiDealDiscountSuggestion.discount.scalarAmount, 'currency')
      }
    },
    formatSuggestedTitle (titles: Array<string>) {
      return [titles.slice(0, -1).join(', '), titles.slice(-1)[0]].join(titles.length < 2 ? '' : ' & ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Cart.vue